import React, { useEffect, useState } from "react";
import { Image } from "@react-pdf/renderer";
import { DALLAS_BASE } from "../api/bases";

const PROXY =
  `${DALLAS_BASE}/v1/onboarding-images/proxy?url=`;

const withProxy = (url) =>
  url ? `${PROXY}${encodeURIComponent(url)}` : null;

const SafeImage = ({ src, fallback, style }) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const checkImage = async () => {
      const primary = withProxy(src);
      const secondary = withProxy(fallback);

      try {
        // ✅ USE GET — NOT HEAD
        const res = await fetch(primary);

        if (res.ok && isMounted) {
          setImageSrc(primary);
        } else if (isMounted) {
          setImageSrc(secondary);
        }
      } catch {
        if (isMounted) {
          setImageSrc(secondary);
        }
      }
    };

    if (src) {
      checkImage();
    } else {
      setImageSrc(withProxy(fallback));
    }

    return () => {
      isMounted = false;
    };
  }, [src, fallback]);

  if (!imageSrc) return null;

  return <Image src={imageSrc} style={style} />;
};

export default SafeImage;
